import type { ReportDimension } from '@up2d8/contracts';

/**
 * De kop van de eerste kolom in de uitsplitsing hangt af van waarop je uitsplitst.
 *
 * Hier stond altijd "Afdeling of ploeg", ook bij "Per soort bericht" (testrapport 28 okt.).
 */
const COLUMN: Record<ReportDimension, string> = {
  group: 'reports.colGroup',
  kind: 'reports.colKind',
  type: 'reports.colType',
  tenant: 'reports.colTenant',
};

export function breakdownColumnKey(dimension: ReportDimension): string {
  return COLUMN[dimension];
}
